export default __webpack_public_path__ + "static/media/quiz-q1.12f38ad0.png";